/** @jsx jsx */
import { css } from "@emotion/react";
import BgCultura from '../images/LP-arabe/bg-cultura.png'
import BgMesquita from '../images/LP-arabe/bg-mesquita.png'

export const educacaoInfantilStyle = css`
  background-color: #FFE8DD;
  padding-top: 120px;
  padding-bottom: 48px;
  scroll-margin-top: 70px;

  img {
    width: 100%;
  }

  .title-sec {
    margin-top: 24px;
    h1 {
      color: #F26F33;
      font-family: Montserrat;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 110%;
    }

    p {
      color: #686868;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      margin-bottom: 0px;
    }
    @media only screen and (max-width: 600px) {
      h1 {
        font-size: 36px;
      }
      .p-bottom {
        margin-bottom: 16px;
      }
    }

    @media only screen and (min-width: 992px) {
      
    }

  }
`

export const diferenciaisStyle = css`
  background-color: #FFFFFF;
  padding: 100px 0;
  scroll-margin-top: 70px;

  img {
    border-radius: 20px;
    width: 100%;
  }

  .diferencias-sec {
    h2 {
      color: #3C3C3C;
      font-family: Montserrat;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 110%;
      margin-bottom: 56px;
      span {
        color: #F26F33;
      }
    }

    h3 {
      color: #F26F33;
      font-family: Montserrat;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
      margin-bottom: 72px;
    }

    p {
      color: #686868;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
    }
    ul {
      padding-left: unset;
    }
    li {
      color: #686868;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; 
      margin-bottom: 12px;
    }

    @media only screen and (max-width: 600px) {
      h2, h3 {
        margin-bottom: 24px;
      }  
    }
  }

  .row-2 {
    margin-top: 56px;
  }

`

export const culturaStyle = css`
  background-image: url(${BgCultura});
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 120px;
  padding-bottom: 48px;
  scroll-margin-top: 70px;
  background-position: 50% 25%;

  img {
    width: 100%;
  }

  .title-sec {
    margin-top: 24px;
    h1 {
      color: #FFFFFF;
      font-family: Montserrat;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 110%;
      width: 100%;
      max-width: 440px;
      margin-top: 120px;
      margin-bottom: 16px;
    }

    p {
      color: #FFFFFF;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      margin-bottom: 120px;
      width: 100%;
      max-width: 440px;
    }
    @media only screen and (max-width: 600px) {
      h1 {
        font-size: 36px;
      }
      .p-bottom {
        margin-bottom: 16px;
      }
    }

    @media only screen and (min-width: 992px) {
      
    }

  }

  .img-mobile {
    display: none;
  }

  @media (min-width: 320px) and (max-width: 767px) {
    padding-top: 80px;
    padding-bottom: 40px;
    background-image: none;
    background-color: #65966D;
    .img-mobile {
      width: 100%;
      display: flex;
    }
    .title-sec {
      h1 {
        margin-top: 24px;
        font-size: 36px;
      }
    }
  }
`

export const MesquitaStyle = css`
  background-image: url(${BgMesquita});
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 120px;
  padding-bottom: 48px;
  scroll-margin-top: 70px;
  background-position: 50% 25%;

  img {
    width: 100%;
  }

  .title-sec {
    margin-top: 24px;
    h1 {
      color: #FFFFFF;
      font-family: Montserrat;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 110%;
      width: 100%;
      max-width: 630px;
      margin-top: 120px;
      margin-bottom: 16px;
    }

    p {
      color: #FFFFFF;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      margin-bottom: 120px;
      width: 100%;
      max-width: 630px;
    }
    @media only screen and (max-width: 600px) {
      h1 {
        font-size: 36px;
      }
      .p-bottom {
        margin-bottom: 16px;
      }
    }

    @media only screen and (min-width: 992px) {
      
    }

  }

  .img-mobile {
    display: none;
  }

  @media (min-width: 320px) and (max-width: 767px) {
    padding-top: 80px;
    padding-bottom: 40px;
    background-image: none;
    background-color: #65966D;
    .img-mobile {
      width: 100%;
      display: flex;
    }
    .title-sec {
      h1 {
        margin-top: 24px;
        font-size: 36px;
      }
    }
  }
`

export const visaoMissaoValoresStyle = css`
  background-color: #FFFFFF;
  padding: 108px 0;
  scroll-margin-top: 70px;

  .box-1 {
    border-radius: 56px;
    background: #DAE7DC;
    padding: 48px;
    margin-bottom: 32px;
    img {
      margin-bottom: 48px;
    }
    h3 {
      color: #3C3C3C;
      font-family: Montserrat;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
      height: 48px;
      width: 100%;
      max-width: 200px;
    }
    p {
      color: #686868;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      margin-bottom: 8px;
      height: 240px;
    }
    ul, li {
      color: #686868;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      margin-bottom: 8px;
      padding-left: 0px;
    }
  }
  .box-2 {
    border-radius: 56px;
    background: #FFE8DD;
    padding: 48px;
    margin-bottom: 32px;
    img {
      margin-bottom: 48px;
    }
    h3 {
      color: #3C3C3C;
      font-family: Montserrat;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
      height: 48px;
      width: 100%;
      max-width: 200px;
    }
    p {
      color: #686868;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      margin-bottom: 8px;
      height: 240px;
    }
  }
`
export const estruturaStyle = css`
  background-color: #FFE8DD;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 108px;
  scroll-margin-top: 70px;

  h2 {
    color: #3C3C3C;
    font-family: Montserrat;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    span {
      color: #F26F33;
      font-weight: 600;
    }
  }

  p {
    color: #686868;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 0px;
  }
`